import React from "react";
import Icon from "@mdi/react";
import { mdiClipboardTextSearchOutline, mdiPlusCircleOutline, mdiCursorDefaultClickOutline } from "@mdi/js";
import { Button, CircularProgress } from "@mui/material";
import styles from "../styles.module.scss";

interface TaskEmptyStateProps {
	hasTasks: boolean;
	isLoading: boolean;
	onSelectFirstTask?: () => void;
}

export const TaskEmptyState: React.FC<TaskEmptyStateProps> = ({ hasTasks, isLoading, onSelectFirstTask }) => {
	if (isLoading && !hasTasks) {
		return (
			<section className={styles.taskEmptyState}>
				<CircularProgress size={26} />
				<h2 className={styles.taskEmptyTitle}>Carregando tarefas</h2>
				<p className={styles.taskEmptyDescription}>Sincronizando dados com a equipe e stream em tempo real.</p>
			</section>
		);
	}

	const title = hasTasks ? "Selecione uma tarefa" : "Nenhuma tarefa encontrada";
	const description = hasTasks ? "Escolha uma task na barra lateral para visualizar o progresso dos itens e subtarefas em tempo real." : "";

	return (
		<section className={styles.taskEmptyState}>
			<div className={styles.taskEmptyIcon}>
				<Icon
					path={hasTasks ? mdiCursorDefaultClickOutline : mdiClipboardTextSearchOutline}
					size={1}
				/>
			</div>

			<h2 className={styles.taskEmptyTitle}>{title}</h2>
			<p className={styles.taskEmptyDescription}>{description}</p>

			<div className={styles.taskEmptyActions}>
				{hasTasks && onSelectFirstTask && (
					<Button
						variant="outlined"
						onClick={onSelectFirstTask}
						className={styles.taskEmptySecondaryButton}
					>
						Selecionar primeira task
					</Button>
				)}
			</div>
		</section>
	);
};
